<template>
  <div class="experimentListDetail">
    <div class="experimentListDetail-title">
      <span @click="goRouter(preUrl.path)">{{ preUrl.name }}&nbsp;&nbsp; / &nbsp;&nbsp;</span>
      <i>实验详情</i>
    </div>
    <div class="experimentListDetail-container">
      <experiment v-if="experimentDetail" :id="experimentDetail.id" @startExperiment="startExperiment"></experiment>
      <div class="experimentListDetail-bottom">
        <div class="list-top">
          <div class="list-top-tabs" @click="toggleActive(0)" :class="active == 0 ? 'addtabsActive' : ''">
            <span>实验介绍</span>
          </div>
          <div class="list-top-tabs" @click="toggleActive(1)" :class="active == 1 ? 'addtabsActive' : ''">
            <span>学习资料</span>
          </div>
          <!-- <div
            class="list-top-tabs"
            @click="toggleActive(2)"
            :class="active == 2 ? 'addtabsActive' : ''"
          >
            <span>实验界面</span>
          </div> -->
        </div>
        <div class="list-bottom">
          <div class="intro" v-if="active == 0" style="width: 1171px">
            <pre>{{ experimentDetail ? experimentDetail.introduce : "" }}</pre>
            <!-- <div v-html="experimentDetail ? experimentDetail.introduce : ''"></div> -->
          </div>
          <div class="content-study" v-if="active == 1" style="width: 1171px">
            <div class="list" v-for="item in experimentAttachTOS" :key="item.id">
              <div class="list-left">{{ item.name }}</div>
              <div class="list-right">
                <i class="el-icon-video-play" @click="play(item.url)"></i><i class="el-icon-download"
                  @click="downlaod(item.url, item.name)"></i>
              </div>
            </div>
            <template v-if="isPlay">
              <div class="playContent">
                <div class="cover"></div>
                <div class="play">
                  <i class="el-icon-circle-close close" @click="isPlay = false"></i>
                  <iframe ref="play" :src="currentUrl" style="width: 100%; height: 100%"></iframe>
                </div>
              </div>
            </template>
          </div>
          <!-- <div class="experimentInterface" v-if="active == 2">
            <div class="cover" v-if="!isStartExperiment">
              <el-button type="primary" class="btn" @click="startExperiment"
                >开始实验</el-button
              >
            </div>
            <div class="startExperiment">
              <i class="el-icon-circle-close close" @click="isPlay = false"></i>
              <iframe
                ref="startExperiment"
                :src="experimentDetail.url + splicingUrl"
                style="width: 100%; height: 850px"
              >
              </iframe>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <el-button type="primary" class="goBack" @click="goRouter(preUrl.path)">返回</el-button>
  </div>
</template>

<script>
import experiment from "@/components/experiment.vue";
export default {
  name: "VirtualimitationExperimentlistdetail",
  components: {
    experiment,
  },
  data() {
    return {
      active: 0,
      experimentDetail: null,
      isPlay: false, //是否播放
      currentUrl: "",
      experimentUrl: "",
      experimentAttachTOS: [],
      preUrl: {
        name: "",
        path: "",
      },
      splicingUrl: "", //拼接的url
      isStartExperiment: false, //是否开始实验
    };
  },

  mounted() {
    if (sessionStorage.getItem("preRouter")) {
      this.preUrl = JSON.parse(sessionStorage.getItem("preRouter"));
    }
    let userInfo = JSON.parse(localStorage.getItem("USER"));
    if (userInfo) {
      if (userInfo.schoolId) {
        this.splicingUrl = `?experimentId=${this.$route.query.id}&schoolId=${userInfo.schoolId}&userId=${userInfo.userId}&product=${process.env.VUE_APP_PRODUCT}&vspToken=${userInfo.token}`;
      } else {
        this.splicingUrl = `?experimentId=${this.$route.query.id}&schoolId=0&userId=${userInfo.userId}&product=${process.env.VUE_APP_PRODUCT}&vspToken=${userInfo.token}`;
      }
    }
    this.getExperimentDetail();
  },

  methods: {
    //监听iframe 自适应
    iframeSelfAdaption() {
      // let h =document.body.outerHeight
      // setInterval(() => {
      //   console.log(this.$refs.startExperiment.innerHTML);
      // }, 3000);
    },

    //开始实验
    startExperiment() {
      if (!JSON.parse(localStorage.getItem("USER"))) {
        this.$message({
          message: "您还没登录，请先登录!",
          type: "warning",
        });
        return;
      }
      // this.active = 2;
      // this.isStartExperiment = true;
      this.$api.experiment
        .clickExperiment(this.experimentDetail.id)
        .then((res) => {
          if (res.errCode == 0) {
            let a = document.createElement("a");
            a.setAttribute(
              "href",
              this.experimentDetail.url + this.splicingUrl
            );
            a.setAttribute("target", "_blank");
            document.body.appendChild(a);
            a.click();
          }
        });
      this.$nextTick(() => {
        // this.$refs.play.style.height = window.screen.availHeight+'px';
        // console.log(this.$refs.play.offsetWidth, this.$refs.play.offsetHeight);
      });
    },
    play(url) {
      this.currentUrl = url;
      this.isPlay = true;
    },
    downlaod(url, name) {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url + "?response-content-type=application/octet-stream";
      a.setAttribute("download", name); // 自定义下载文件名
      a.click();
      document.body.removeChild(a);
    },
    getExperimentDetail() {
      this.$api.experiment.queryExperiment(this.$route.query.id).then((res) => {
        this.experimentDetail = res.data;
        this.experimentAttachTOS = res.data.experimentAttachTOS;
        this.experimentUrl = res.data.url;
      });
    },
    goRouter(path) {
      this.$router.push(path);
    },
    toggleActive(index) {
      this.active = index;
      if (index == 2) {
        this.$nextTick(() => {
          this.iframeSelfAdaption();
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.playContent {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  .cover {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.5;
  }

  .play {
    width: 1550px;
    height: 850px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    .close {
      position: absolute;
      top: -20px;
      right: -20px;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.experimentListDetail {
  width: 100%;
  position: relative;

  .experimentListDetail-container {
    padding: 28px;
    box-sizing: border-box;
    background: #fff;
    min-height: 790px;

    .experimentListDetail-bottom {
      margin-top: 28px;
      padding-top: 30px;
      border-top: 1px solid #eef2fa;

      .list-top {
        width: 100%;
        display: flex;
        justify-content: start;

        .list-top-tabs {
          width: 66px;
          height: 25px;

          &:nth-child(2) {
            margin: 0 32px;
          }

          span {
            font-size: 16px;
            font-family: PingFang-SC;
            font-weight: 600;
            line-height: 22px;
            opacity: 1;
            cursor: pointer;
          }
        }
      }

      .list-bottom {
        // width: 1171px;
        padding-top: 30px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #424346;
        opacity: 1;

        .intro {
          pre {
            font-family: PingFang-SC;
            white-space: pre-wrap;
          }
        }

        .experimentInterface {
          position: relative;
          width: 100%;

          .startExperiment {
            width: 100%;
            min-height: 850px;
          }

          .cover {
            width: 100%;
            height: 850px;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.6);

            .btn {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translateX(-50%) translateY(-50%);
            }
          }
        }

        .content-study {
          padding: 0 0 10px;
          box-sizing: border-box;
          width: 100%;

          .list {
            width: 100%;
            height: 58px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 12px;
            box-sizing: border-box;
            height: 50px;
            line-height: 58px;
            border-bottom: 1px solid #eef2fa;

            &:hover {
              background: #f6f7fb !important;
            }

            .list-right {
              i {
                font-size: 20px;
                margin-right: 20px;
                color: #409eff;
                cursor: pointer;
              }
            }

            .list-left {
              font-size: 14px;
              font-family: PingFang-SC;
              font-weight: 500;
              line-height: 20px;
              color: #424346;
            }
          }
        }
      }
    }
  }

  .experimentListDetail-title {
    margin-bottom: 16px;

    span,
    i {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
      font-style: normal;
    }

    span {
      color: #939393;
      cursor: pointer;
    }
  }

  .goBack {
    position: absolute;
    top: 60px;
    right: 30px;
  }
}

.addtabsActive {
  border-bottom: 2px solid #1880fa;

  span {
    color: #1880fa !important;
  }
}

.fontSizeCenter {
  display: inline-block;
  width: 100%;
  text-align: center;
}
</style>